// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".share[data-v-92c506c2]{color:var(--svg-fill);display:flex;padding-bottom:31px;border-bottom:2px solid rgba(1,4,7,.05)}.share svg[data-v-92c506c2]{margin-left:15px}.share svg path[data-v-92c506c2]{transition:.3s ease}.share a:hover svg path[data-v-92c506c2]{fill:var(--tbc-blue)}.share p[data-v-92c506c2]{color:#7d8a98}", ""]);
// Exports
module.exports = exports;
